export interface ISsTransactionPayments {
  action: string; // 'deposit';
  amount_cents: number; // 1000;
  created_at: string; // '2021-09-20T10:57:13.314Z';
  currency: string; // 'AUD';
  finished_at: string; // '2021-09-20T10:57:49.806Z';
  id: number; // 176232;
  payment_system: string; // 'Credit Card';
  recallable: boolean; // false;
  success: boolean; // true;
  system_name: string; // 'devcode';
  date?: string;
  status?: string;
  formated_cent?: number;
  formattedAmount?: string;
  formattedCurrency?: string;
  brand: string;
}

export interface ISsTransactionBets {
  created_at: string; // '2022-01-31T12:44:25.699Z';
  currency: string; // 'AUD';
  finished_at: string; // '2022-01-31T12:44:25.870Z';
  game: string; // '1x2gaming/PirateArmada';
  provider: string; // '1x2gaming';
  title: string; // 'Pirate Armada';
  total_bets: number; // 30;
  total_wins: number; // 0;
  date?: string;
  formattedTotalWins?: {
    formattedAmount: string;
    formattedCurrency: string;
  };
  formattedTotalBets?: {
    formattedAmount: string;
    formattedCurrency: string;
  };
  id: number;
}

export interface ISsTransactionBonuses {
  activatable: boolean; // false;
  activatable_until: any; // null;
  amount_cents: number; // 3900;
  amount_wager_cents: number; // 0;
  amount_wager_requirement_cents: number; // 124800;
  cancelable: boolean; // false;
  created_at: string; // '2022-02-23T20:35:13.085Z';
  currency: string; // 'BTC';
  id: number; // 676519;
  stage: string; // 'expired';
  strategy: string; // 'exchange';
  title: string; // 'Exchange comp points 10 lvl';
  valid_until: string; // '2022-02-26T20:35:13.091Z';
  date?: string;
  formated_cent?: number;
  formattedAmount?: string;
  formattedCurrency?: string;
  dateValidUntil?: string;
}

export interface IHistoryItem {
  id?: number;
  created_at: string;
  finished_at?: string;
  stage?: string;
  [key: string]: any;
}

export enum EHistoryFilters {
  Currency = 'currency',
  Status = 'status',
  Action = 'action',
}

export enum ETransactionStatus {
  Pending = 'pending',
  Discarded = 'discarded',
  Accepted = 'accepted',
}

export enum ETransactionAction {
  Deposit = 'deposit',
  Cashout = 'cashout',
  Reward = 'reward',
}

export enum EBonusStatus {
  WagerDone = 'wager_done',
  Lost = 'lost',
  HandleBets = 'handle_bets',
  Canceled = 'canceled',
  Expired = 'expired',
}
